<template>
  <el-row type="flex" align="middle" style="height: 60px;background-color: #0E131A;color: #ffffff;">
    <el-col :span="8" class="flex-middle">
      <template v-if="appInfo">
        <el-image :src="appInfo.logoUrl" class="circle" style="margin-left: 20px;height: 36px;width: 36px;"></el-image>
        <span style="margin-left: 10px;font-size: 14px;">{{appInfo.organizationName}}</span>
      </template>
    </el-col>
    <el-col :span="18" class="text-right" style="color: #aaaaaa;">
      <div v-if="false" class="inline-block" style="margin-right: 20px;">
        <i class="icon icon_notification-filling"></i>
      </div>
      <!--      <span style="margin-right: 20px;">{{currentUserInfo.username}}</span>-->
      <!--      <div class="inline-block pointer" @click="logout">-->
      <!--        <span style="margin-right: 5px;">退出</span>-->
      <!--        <i class="icon icon_exit" style="margin-right: 20px;"></i>-->
      <!--      </div>-->
      <el-dropdown trigger="click" style="margin-right: 20px;" @command="handleCommand">
        <span class="el-dropdown-link" style="font-size: 20px;color: #ffffff">
          {{currentUserInfo.username}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><i class="el-icon-unlock"></i>修改密码</el-dropdown-item>
          <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>
<script>

export default {
  name: 'page-top',
  components: {},
  props: [],
  data () {
    return {
      currentUserInfo: this.$store.state.currentUserInfo,
      appInfo: this.$store.state.appInfo
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async handleCommand (command) {
      // debugger
      if (command == 'logout') {
        await this.logout();
      } else {
        this.$router.push(`/changePassWord/changeOldPass`)
      }
    },
    async logout () {
      try {
        let confirm = await this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          this.$router.push('/index/login')
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
